import cs from '../messages/cs.json' with { type: 'json' };
import en from '../messages/en.json' with { type: 'json' };
export const CS_MESSAGES = cs;
export const EN_MESSAGES = en;
/** Registrovane katalogy dle jazykoveho kodu (BCP 47 primarni podtag). */
export const REGISTRY = new Map([
    ['cs', CS_MESSAGES],
    ['en', EN_MESSAGES],
]);
export function registerMessages(locale, catalog) {
    REGISTRY.set(locale, catalog);
}
export function getRegisteredLocales() {
    return [...REGISTRY.keys()];
}
//# sourceMappingURL=catalog.js.map